<template>
    <v-container v-if="item" class="d-flex justify-end">
        <v-progress-circular @mouseover="currency.current = 'near'" :size="$mobile ? 100 : 150" :color="item.paid ? '#C8E6C9' : '#43A047'" rotate="-90" :width="$mobile ? 1 : 2" @mouseout="currency.current = currency.default" :value="progressValue(item.uniqueIdString)">
            <div>
                <v-overlay v-show="item.approximateFundingPercentage > 0" opacity="0" absolute>
                    <div class="d-flex justify-center align-center">
                        <number :class="{ 'invisible': item.paid && complete, 'text-h4' : $mobile, 'text-h2': !$mobile }" @complete="complete = true" @update="value => updateHandler(item.uniqueIdString, value)" v-if="item.approximateFundingPercentage > 0" :ref="`prettyNumber-${item.uniqueIdString}`" style="color: #43a047; position: absolute" :to="item.approximateFundingPercentage" :duration="item.paid ? 1 : randomDuration()" :delay="item.paid ? 0 : randomDelay()" easing="Power4.easeIn" />
                        <span :class="item.paid && complete ? 'visible' : 'invisible'" :style="$mobile ? 'top: -40px' : 'top: -65px'" style="color: #43a047; position: absolute"  class="font-weight-light text-md-body-1 text-sm-body-2 text-uppercase">{{ item.purchased ? 'granted' : 'paid' }}</span>
                    </div>
                </v-overlay>
                <span :class="{ 'invisible': item.paid && complete, 'symbol-mobile': $mobile }" class="symbol">%</span>
            </div>
        </v-progress-circular>
        <v-progress-circular v-show="item.paid && !item.purchased" class="second-progress" @mouseover="currency.current = 'near'" :size="$mobile ? 100 : 150" color="#00C853"  :width="$mobile ? 1 : 2" @mouseout="currency.current = currency.default" :rotate="(counter && counter.minutes * 100 / 60) - 90" :value="(counter && counter.seconds * 100 / 60) + 2">
            <div>
                <v-overlay opacity="0" absolute>
                    <bnft-time-counter v-model="counter" :start="item.paid"></bnft-time-counter>
                </v-overlay>
                <span :class="{ 'visible': item.paid && complete, 'symbol-mobile': $mobile }" class="symbol">X</span>
            </div>
        </v-progress-circular>
        <v-progress-circular v-show="item.paid && item.purchased && delay3" class="third-progress" @mouseover="currency.current = 'near'" :size="$mobile ? 100 : 150" color="#43A047" rotate="-90" :width="$mobile ? 1 : 2" @mouseout="currency.current = currency.default" :value="progressValue(item.uniqueIdString)">
            <div>
                <v-overlay opacity="0" absolute>
                    <bnft-time-counter :start="item.paid" :end="item.purchased"></bnft-time-counter>
                </v-overlay>
                <span :class="{ 'visible': item.paid && complete, 'symbol-mobile': $mobile }" class="symbol"><div class="happy-symbol">: )</div></span>
            </div>
        </v-progress-circular>
    </v-container>
</template>
<style scoped>
.symbol {
    color: #f5f5f5;
    font-size: 100px;
}
.symbol-mobile {
    font-size: 70px;
    transition-delay: 1s;
    transition-property: display 1s;
}
.happy-symbol {
    transform: rotate(90deg);
}
.invisible {
    visibility: hidden;
    opacity: 0;
    transition: visibility 1.5s ease-in-out, opacity 1.5s ease-in-out;
}
.visible {
    visibility: visible;
    opacity: 1;
    transition: visibility 1.5s linear, opacity 1.5s linear;
}
.second-progress {
    position: absolute;
}
.third-progress {
    position: absolute;
}
</style>
<script>
import Vue from 'vue';
import VueNumber from '@667/vue-number-animation';
import BnftTimeCounter from '../components/BnftTimeCounter.vue';

Vue.use(VueNumber);

export default {
    name: 'BnftProgress',
    props: {
        item: Object,
    },
    components: {
        BnftTimeCounter,
    },
    data: function () {
        return {
            NODE_ENV: process.env.NODE_ENV,
            currency: {
                default: 'usd',
                current: 'usd',
            },
            progressValues: {},
            complete: false,
            delay3: false,
            counter: undefined,
        };
    },
    mounted() {
        const self = this;
        setTimeout(() => self.delay3 = true, 2000);
    },
    methods: {
        updateHandler(uniqueIdString, value) {
            this.$set(this.progressValues, uniqueIdString, value)
        },
        progressValue(uniqueIdString) {
            return this.progressValues[`${uniqueIdString}`];
        },
        randomDuration() {
            return Math.random() * 5
        },
        randomDelay() {
            return Math.random()
        }
    }
};
</script>
